import React from "react";
import { motion } from "framer-motion";
import { Container, Stack, Loader, Image } from "@mantine/core";
import shadow from "../assets/img/shadow.svg";

export const Screen = React.memo(({ screen, initial, animate, transition }) => {
  const MotionContainer = motion(Container);
  const Component = screen
    ? React.lazy(() => import(`../screens/${screen}`))
    : null;

  return (
    <React.Suspense
      fallback={
        <div
          style={{
            minHeight: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Loader size="xl" variant="dots" />
        </div>
      }
    >
      <MotionContainer
        initial={initial || { opacity: 0.3, scale: 0.7 }}
        animate={animate || { opacity: 1, scale: 1 }}
        transition={transition || { duration: 0.2 }}
        sx={(theme) => ({
          maxWidth: "1200px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        })}
      >
        <Container
          size="lg"
          sx={(theme) => ({
            width: "100%",
            background:
              theme.colorScheme === "dark"
                ? theme.colors.dark[5]
                : theme.colors.gray[0],
            borderRadius: "32px",
            padding: "52px",
            boxShadow: "0 0 100px 0 rgba(131, 93, 255, 0.31)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          })}
        >
          {Component ? <Component /> : <>Invalid component</>}
        </Container>
        <Image src={shadow} sx={{ marginTop: "32px" }} />
      </MotionContainer>
    </React.Suspense>
  );
});
